<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addEditCityModal"
        persistent
        max-width="500px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              >
                <span class="headline">
                  {{ isUpdate ? $t('datatable.updateCityTitle') : $t('datatable.addNewCityButton') }}
                </span>
              </v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-layout wrap>
                <v-flex
                  xs12
                >
                  <v-select
                    autocomplete
                    :items="governorates"
                    item-value="value"
                    v-model="formData.governorate_id_fk"
                    :error-messages="errors.collect('governorate_id')"
                    data-vv-name="governorate_id"
                    :label="$t('columns.governorate') + '*'"
                    v-validate="'required'"
                    single-line
                  >
                  </v-select>
              </v-flex>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('columns.name') + ' *'"
                    v-model="formData.city_name"
                    :error-messages="errors.collect('Name')"
                    v-validate="'required'"
                    data-vv-name="Name"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('columns.nameArabic') + ' *'"
                    v-model="formData.city_name_ar"
                    :error-messages="errors.collect('Name (Arabic)')"
                    v-validate="'required'"
                    data-vv-name="Name (Arabic)"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('columns.nameKurdish') + ' *'"
                    v-model="formData.city_name_ku"
                    :error-messages="errors.collect('Name (Kurdish)')"
                    v-validate="'required'"
                    data-vv-name="Name (Kurdish)"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >{{ $t('common.cancel') }}</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto" class="submit-btn-spacing"
                outline
                color="success"
              >
                {{ isUpdate ? $t('common.save') : $t('common.add') }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['addEditCityModal', 'formData', 'governorates', 'isUpdate'],

  data() {
    return {
      loading: false
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.isUpdate) {
            Axios.put(`api/city/${this.formData.city_id}`, this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                swal({
                  title: this.$t('common.updatedSuccessfully'),
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                swal(this.$t('common.error'), error.response.data.message, 'error')
              })
          } else {
            Axios.post('api/city', this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                swal({
                  title: this.$t('common.addedSuccessfully'),
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                swal(this.$t('common.error'), error.response.data.message, 'error')
              })
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/city/addEditCity.vue